export default __webpack_public_path__ + "static/media/093-down-arrow-5.121422d9.png";